require('./mainmenu');
require('./bannerfix');
require('./somewall');
require('./image_carousel');
require('./custom_form');
//require('./ad_banner');



//////////////////
// WEBPACK FOOTER
// /srv/mestis/mestis.git/liiga/static/liiga/common/js/common.js
// module id = 2
// module chunks = 0